<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import { todoComputed, todoMethods } from "@/state/helpers";

/**
 * Starter component
 */
export default {
  page: {
    title: "Master",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {};
  },

  computed: {
    ...todoComputed,
    /**
     * Total no. of records
     */

    title() {
      return this.$t("master.dataMaster");
    },
  },

  methods: {
    ...todoMethods,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{
                $t("master.dataMaster")
              }}</span>
            </template>
            <b-row class="mc-card__list">
              <b-col md="6" v-if="$store.state.config.mode == 'development'">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Customer' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_people"> </i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.pelanggan') }}</h4>
                    <p>{{ $t('master.textKendaraan') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Fleet' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_car"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t("master.kendaraan") }}</h4>
                    <p>{{ $t("master.textKendaraan") }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Tracking' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_radio"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t("master.pelacak") }}</h4>
                    <p>{{ $t("master.textPelacak") }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Address' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_pin"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t("master.alamat") }}</h4>
                    <p>{{ $t("master.textAlamat") }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master User' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_person"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.pengguna') }}</h4>
                    <p>{{ $t('master.textPengguna') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Employee' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_people"> </i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.karyawan') }}</h4>
                    <p>{{ $t('master.textKaryawan') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col md="6" v-if="$store.state.config.mode == 'development'">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Service' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_settings"> </i>
                  <div class="mc-card__list-item-content">
                    <h4>Pemeliharaan Kendaraan</h4>
                    <p>Mengelola data pemeliharaan kendaraan pada sistem</p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>